import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type NotificationType = "base" | "secondary" | "success" | "error" | "inverse" | "primary" | "tertiary" | "warning" | "info" | "none";

export interface Notification {
    id: string;
    type: NotificationType;
    message: string;
}

interface NotificationsState {
    items: Notification[];
}

const initialState: NotificationsState = {
    items: []
};

const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        addNotification: (state, action: PayloadAction<Notification>) => {
            state.items.push(action.payload);
        },
        removeNotification: (state, action: PayloadAction<string>) => {
            state.items = state.items.filter(notification => notification.id !== action.payload);
        }
    }
});

export const {
    addNotification,
    removeNotification
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
